import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import EllipsisTypography from '../../EllipsisTypography/EllipsisTypography';
import { StatusFormatter } from '../../NRMisconfigurationTable/NRMisconfigurationTableCustomComponents/NRMisconfigurationStatusProvider/NRMisconfigurationStatusProvider';
import { DescriptionSecondary, HeaderBlock } from '../activityFeedHeaderShared';

function MisconfigChangedHeader({ entity, item, activity, linkProps }) {
  const theme = useTheme();
  return (
    <HeaderBlock
      primary={
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <EllipsisTypography {...linkProps} variant="body2" sx={{ wordBreak: 'break-all', color: theme.palette.blue.link, cursor: 'pointer' }}>
            {entity.checkName}
          </EllipsisTypography>
          <Typography sx={{ mx: 1, whiteSpace: 'nowrap' }} variant="body2" children={`${activity} to `} />
          <StatusFormatter value={entity?.newStatus} uppercase={entity?.newStatus?.toLowerCase() === 'na'} small={true} />
        </Box>
      }
      secondary={<DescriptionSecondary item={item} />}
    />
  );
}

export default MisconfigChangedHeader;
